(function(){
  var gal=document.getElementById('ggGal'), track=document.getElementById('ggTrack');
  if(!gal||!track) return;
  var slides=[].slice.call(track.querySelectorAll('.slide'));
  var thumbs=[].slice.call(document.querySelectorAll('#ggThumbs .thumb'));
  var count=document.getElementById('ggCount'), cur=0, timer;
  function mark(i){
    cur=i;
    if(count) count.textContent=(i+1)+' / '+slides.length;
    thumbs.forEach(function(t,k){t.classList.toggle('on',k===i);});
    var t=thumbs[i];
    if(t&&t.parentNode){var p=t.parentNode;p.scrollLeft=Math.max(0,t.offsetLeft-p.clientWidth/2+t.clientWidth/2);}
  }
  function goTo(i,smooth){
    if(!slides.length) return;
    i=Math.max(0,Math.min(slides.length-1,i));
    var target=i*track.clientWidth;
    try{track.scrollTo({left:target,behavior:smooth===false?'auto':'smooth'});}catch(e){track.scrollLeft=target;}
    mark(i);
    clearTimeout(timer);
    timer=setTimeout(function(){
      if(Math.abs(track.scrollLeft-target)>2){track.style.scrollBehavior='auto';track.scrollLeft=target;track.style.scrollBehavior='';}
    },500);
  }
  function goToMid(mid,smooth){
    if(!mid) return;
    for(var i=0;i<slides.length;i++){if(slides[i].dataset.mid==String(mid)){goTo(i,smooth);return;}}
  }
  var deb;
  track.addEventListener('scroll',function(){
    clearTimeout(deb);
    deb=setTimeout(function(){var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));if(i!==cur)mark(i);},80);
  },{passive:true});
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(t.dataset.i,10));});});
  var pv=gal.querySelector('.gal-nav.prev'), nx=gal.querySelector('.gal-nav.next');
  if(pv) pv.addEventListener('click',function(){goTo(cur-1);});
  if(nx) nx.addEventListener('click',function(){goTo(cur+1);});
  track.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight'){goTo(cur+1);e.preventDefault();}
    if(e.key==='ArrowLeft'){goTo(cur-1);e.preventDefault();}
  });
  window.addEventListener('resize',function(){goTo(cur,false);});
  window.ggGallery={goTo:goTo,goToMid:goToMid};
  if(gal.dataset.start) goToMid(gal.dataset.start,false);
})();